<template>
  <v-row no-gutters>
    <v-col cols="4" class="d-flex flex-column align-center justify-center">
      <v-sheet class="text-left">
        <div>
          <span class="text-primary text-overline pr-4">
            {{ `${$t("labels.kpi-status").toUpperCase()}` }}
          </span>
          <span class="text-secondary font-weight-bold">
            {{ `${$t("labels.status." + kpiStatus.toLowerCase())}` }}
          </span>
        </div>

        <span class="text-overline pr-4">
          {{ $t("labels.schedule") }}
        </span>
        <span class="font-weight-medium text-secondary">
          {{ scheduleValue || "" }}
          {{ scheduleTime ? $t(`labels.${scheduleTime}`, scheduleValue) : "" }}
        </span>
      </v-sheet>
    </v-col>
    <v-col cols="4" class="text-center d-flex align-start justify-center">
      <v-sheet class="text-center pt-0">
        <v-switch
          v-model="currentState"
          false-value="PENDING"
          false-icon="mdi-pause"
          true-value="RUNNING"
          true-icon="mdi-play"
          hide-detail="auto"
          color="green"
          @click="toggleCronJob(currentState)"
          messages=" "
          class="text-center"
        >
          <template v-slot:label>
            <div class="font-weight-medium text-overline">
              {{ `${$t("labels.status." + currentState.toLowerCase())}` }}
            </div>
          </template>
          <template v-slot:message>
            <div
              v-if="kpiStatus !== currentState"
              class="text-caption text-warning font-weight-normal mt-n3"
            >
              <span class="text-warning font-weight-bold"> * </span>
              <span>{{ $t("strings.status-changed") }}</span>
            </div>
            <div
              v-else
              class="text-caption text-grey-darken-4 font-weight-normal mt-n3"
            >
              <span>{{ $t("strings.kpi-activated") }}</span>
            </div>
          </template>
        </v-switch>
      </v-sheet>
    </v-col>
    <v-col cols="4" class="text-center d-flex align-center justify-center">
      <v-sheet class="text-left">
        <span class="text-primary text-overline pr-4">
          {{ $t("strings.last-update") }}
        </span>
        <span class="text-secondary font-weight-bold">
          {{ lastValue }}
        </span>
        <br />
        <span class="text-primary text-overline pr-4">
          {{ $t("strings.on-date") }}
        </span>
        <span class="text-secondary font-weight-bold">
          {{ formatDate(lastUpdate) }}
        </span>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import { formatDateToLocale } from "../composables/fetchChartData.js";
export default {
  name: "StatusAutomatic",
  data() {
    return {
      currentState: "", // Initialize as empty
    };
  },
  computed: {
    kpiStatus() {
      const kpi = this.getKpiFromSession();
      const status = kpi?.formula?.job?.status;
      return status ? status.toUpperCase() : "PENDING";
    },
    lastUpdate() {
      const kpi = this.getKpiFromSession();
      return kpi?.lastUpdate || "";
    },
    lastValue() {
      const kpi = this.getKpiFromSession();
      return kpi?.lastValue !== undefined ? String(kpi.lastValue) : "";
    },
    scheduleValue() {
      const kpi = this.getKpiFromSession();
      return kpi?.formula?.job?.schedule?.value || "";
    },
    scheduleTime() {
      const kpi = this.getKpiFromSession();
      return kpi?.formula?.job?.schedule?.time || "";
    },
  },
  methods: {
    getKpiFromSession() {
      try {
        const raw = sessionStorage.getItem("kpi");
        return raw ? JSON.parse(raw) : {};
      } catch (e) {
        console.error("Error reading KPI from session storage:", e);
        return {};
      }
    },
    formatDate(dateString) {
      return formatDateToLocale(dateString);
    },
    toggleCronJob(newStatus) {
      this.currentState = newStatus === "RUNNING" ? "PENDING" : "RUNNING";
      this.$emit("toggleCronJob", this.currentState);
    },
  },
  mounted() {
    this.currentState = JSON.parse(JSON.stringify(this.kpiStatus)); // Set initial value of currentState
  },
};
</script>
